module.exports = __webpack_public_path__ + "img/guest-active.8bd6c73e.png";